'use strict'

angular.module('webremote.service.audioPlayer', []).factory('audioPlayerService', function ($injector, httpService, toastr, webRtcService) {
  var service = {}
  const musicMetadata = require('music-metadata-browser')

  class AudioPlayer {
    constructor () {
      this.audioElement = undefined
      this.currentItem = ''
      this.lastPlayedItem = ''
      this.visible = false
      this.meta = {}
      this.lastError = {}
      this.loadinStates = {
        meta: false
      }
      this.encodedCover = ''

      this.webRtcService = webRtcService.getInstance('ListenIn')

      this.setPlayObject.bind(this)
    }

    async setPlayObject (playObject, metaDataOverride) {
      // Reset meta information
      this.meta = {}
      // Stop running stream
      this.stop()

      // HTTP and WebRTC listenIn
      if (playObject.member !== undefined && playObject.member.objectClass === 'stream') {
        let systemConfig = []
        const om = $injector.get('objectManagerService').getObjectManager()
        await om.collection('systemConfig').then((v) => {
          systemConfig = Array.from(v.values())[0]
        })
        this.UseWebRtc = Object.prototype.hasOwnProperty.call(systemConfig.member.audio.listenInMode, 'webRtc')

        if (location.protocol !== 'https:' && location.hostname !== 'localhost' && this.UseWebRtc) {
          toastr.warning('WebRTC ListenIn Mode selected, but not using HTTPS. Falling back to Http ListenIn.', 'Warning: No HTTPS', {
            closeButton: true, progressBar: true, positionClass: 'toast-bottom-right'
          })
          this.UseWebRtc = false
        }

        this.webRtcService.tappedStream = playObject.member.uuid
        if ((location.protocol === 'https:' || location.hostname === 'localhost') && this.UseWebRtc) {
          await this.webRtcService.startConnection('audio', webRtcService.MediaMode.RECEIVE_ONLY, webRtcService.MediaMode.OFF)
        } else {
          this.currentItem = '/webapi/http/listen/' + playObject.member.uuid
        }

      // Handle files from archive
      } else {
        this.importMetadata(this.getFilePath(playObject))
        this.currentItem = this.getFilePath(playObject)
        this.UseWebRtc = false
      }

      // Handle meta data override
      if (metaDataOverride) {
        this.meta = metaDataOverride
      }

      // Auto play, if ready
      this.audioElement.addEventListener('loadeddata', () => {
        if (this.audioElement.readyState >= 3) {
          this.audioElement.play()
        }
      })

      this.visible = true
    }

    async importMetadata (url) {
      this.loadinStates.meta = true

      musicMetadata.fetchFromUrl(url, { skipPostHeaders: this.isLivestream() }).then(meta => {
        this.meta = meta
        if (Array.isArray(this.meta.common.picture) && this.meta.common.picture[0].data !== undefined) {
          let base64String = ''
          for (var i = 0; i < this.meta.common.picture[0].data.length; i++) {
            base64String += String.fromCharCode(this.meta.common.picture[0].data[i])
          }
          this.meta.common.picture[0].base64String = 'data:' + this.meta.common.picture[0].format + ';base64,' + window.btoa(base64String)
        }
      })

      this.loadinStates.meta = false
    }

    isLoading (key) {
      return this.loadinStates[key]
    }

    isLivestream () {
      if (this.audioElement.duration !== undefined) {
        return this.audioElement.duration.toString() === 'Infinity'
      } else {
        return false
      }
    }

    getFilePath (file) {
      return httpService.webapiUrl + 'archive' + file.path + file.name
    }

    toggleVisibility () {
      this.visible = !this.visible
    }

    setVolume (volume) {
      if (this.audioElement) {
        this.audioElement.volume = volume
      }
    }

    setAudioElement (audioElement) {
      this.audioElement = audioElement
    }

    async play () {
      if (this.UseWebRtc) {
        if (this.webRtcService.tappedStream) {
          await this.webRtcService.startConnection('audio', webRtcService.MediaMode.RECEIVE_ONLY, webRtcService.MediaMode.OFF)
        }
      } else {
        if (this.currentItem.length === 0 || this.currentItem.includes('/webapi/http/listen/stop/')) {
          this.currentItem = this.lastPlayedItem
        }
      }
      // Auto play, if ready
      this.audioElement.addEventListener('loadeddata', () => {
        if (this.audioElement.readyState >= 3) {
          this.audioElement.play()
        }
      })
    }

    stop () {
      // Save current item
      if (!this.currentItem.includes('/webapi/http/listen/stop/') && this.currentItem !== '') {
        this.lastPlayedItem = this.currentItem
      }
      this.audioElement.pause()
      if (this.webRtcService.tappedStream) {
        this.currentItem = '/webapi/http/listen/stop/' + this.webRtcService.tappedStream
      }
      this.audioElement.currentTime = 0
      if (this.UseWebRtc) {
        this.webRtcService.stop()
      }
    }

    close () {
      this.stop()
      this.visible = false
      this.meta = {}
    }

    seekTo (value) {
      this.audioElement.currentTime = Math.round(value)
    }

    streamStoppedCallback (uuid) {
      if (this.currentItem.search(uuid) !== -1) {
        this.close()
      }
    }
  }

  service.control = new AudioPlayer()

  return service
})
